/* eslint-disable */
import React, { useContext } from 'react';
import { useTheme  } from '@emotion/react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import {
  MASK_ZINDEX
} from '../utils';

const propTypes = {
  opacity: PropTypes.string,
  zIndex: PropTypes.number,
  top: PropTypes.string,
  text: PropTypes.string,
  textFontSize: PropTypes.string,
  textFontWeight: PropTypes.string,
};

const defaultProps = {
  opacity: '0.8',
  textFontSize: '22px',
  textFontWeight: '700'
};

const Mask = (props) => {
  const { top, opacity, text, textFontWeight, textFontSize } = props;
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let mask;
  if (theme && theme.mask) {
    mask = theme.mask;
  } else {
    mask = context.theme.mask;
  }

  const styles = StyleSheet.create({
    mask: {
      ...mask.props,
      position: 'absolute',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      top: props.top ? props.top : '0',
      right: '0',
      zIndex: MASK_ZINDEX,
      opacity: opacity
    },
    'text': {
      ...mask.textProps,
      fontSize: textFontSize,
      fontWeight: textFontWeight
    }

  });

  return (
    <div className={css(styles.mask)}>
      {text ? <p className={css(style.textStyles)}>{props.text}</p> : null}
      </div>
  );
};

Mask.propTypes = propTypes;
Mask.defaultProps = defaultProps;
export { Mask };
